import { GenerateInstructorBioInput } from "@hubcapp/types";

import { MutationHookOptions, useMutation } from "@apollo/react-hooks";
import generateInstructorBio from "../graph-ql/generateInstructorBio.graphql";

export const useMutationGenerateInstructorBio = (
  opts: MutationHookOptions<
    { generateInstructorBio: string },
    {
      input: GenerateInstructorBioInput;
    }
  > = {},
) =>
  useMutation(generateInstructorBio, {
    ...opts,
  });
